export const PROFILE_FEATURE_KEY = 'profile';
